import React from "react";

// Jednoduchá galerie pro zakázku – upload stejně jako Foto dokumentace.
// Očekává endpoint: POST /api/foto/upload  (multipart/form-data)
// fields: files[] + orderId + scope
export default function FotogalerieZakazky({
  ensureOrderId,

  title = "Galerie",
  scope,
  orderId,
  items,
  onAdd,
  apiFetch,
}) {
  const list = Array.isArray(items) ? items : [];

  const upload = async (fileList) => {
    const arr = Array.from(fileList || []);
    if (!arr.length) return;

    let oid = orderId;
    if (!oid && typeof ensureOrderId === "function") {
      try { oid = await ensureOrderId(); } catch (e) { oid = ""; }
    }
    if (!oid) {
      alert("Chybí ID zakázky – nejdřív založ/načti zakázku.");
      return;
    }

    const fd = new FormData();
    for (const f of arr) fd.append("files", f); // stejné jako Foto dokumentace
    fd.append("orderId", String(oid));
fd.append("kategorie", String(scope || "vyjezd"));
const r = await apiFetch("/api/foto/upload", { method: "POST", body: fd });
    if (!r?.ok) throw new Error(r?.error || "upload failed");

    const out = r.files || r.items || (r.file ? [r.file] : []);
    const uploaded = Array.isArray(out) ? out : [];
    if (uploaded.length) onAdd?.(uploaded);
  };

  return (
    <div style={{ margin: "10px 0", padding: 12, border: "1px solid rgba(0,0,0,0.12)", borderRadius: 10 }}>
      <div style={{ fontWeight: 900, marginBottom: 6 }}>📷 {title}</div>

      <input
        type="file"
        accept="image/*"
        multiple
        onChange={async (e) => {
          try {
            await upload(e.target.files);
            e.target.value = "";
          } catch (err) {
            console.error("gallery upload fail", scope, err);
            alert("Nahrání fotek se nepovedlo.");
          }
        }}
      />

      {list.length > 0 && (
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginTop: 8 }}>
          {list.map((f, idx) => {
            const src = f?.path || f?.url || f?.previewUrl || f?.src;
            if (!src) return null;
            return (
              <a key={(src || "x") + "_" + idx} href={src} target="_blank" rel="noreferrer">
                <img
                  src={src}
                  alt={f?.name || "foto"}
                  style={{
                    width: 120,
                    height: 90,
                    objectFit: "cover",
                    borderRadius: 8,
                    border: "1px solid rgba(0,0,0,0.15)",
                  }}
                />
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
}
